import React from "react";

const MPI = () => {
  return <section className="py-5 fw-semibold">Do Not Sell My Personal Info...</section>;
};

export default MPI;
